import {
  Highlights,
  WtpBlue,
  Deadline,
  Red,
  Title,
  List,
  Item,
  Description,
  Bold,
  Diamond,
  SectionHeader,
  DTitle,
  DLine,
} from "./commonDraw";

const Cn = {
  aboutPage: {
    title: "介绍",
    about_1: (
      <>
未来法律事务所自2010年成立以来，长期办理企业法律顾问、反垄断与企业争议、知识产权等业务。我们从企业法律顾问与争议应对的双重视角，统筹审视科技企业的技术权益保护与商业化、跨境交易、美国业务与诉讼，以及关税与贸易问题。
        <br />
        <br />
       未来法律事务所的业务主要分为四大领域：①科技企业法律顾问，②知识产权与技术权益战略，③海外拓展与出口法律服务，④美国业务与诉讼应对。在企业实际经营过程中，这些问题往往相互交织，因此我们会根据具体事项进行跨领域综合分析。<br />
        <br />
      即使是一份技术商业合作合同，也可能同时涉及投融资与公司治理、知识产权归属与许可、关税与通关、出口管制以及美国法项下的争议风险。未来法律事务所不会孤立审视各项问题，而是以客户的商业模式、技术资产、交易对手及目标市场为基础，梳理应优先审查和推进的事项。 <br />
        <br />
     </>
    ),

    about_2: `与Lee International专利法律事务所、Creative Answers (LICA)、专利法人WEthePEOPLE等在 IP·技术领域的主要合作伙伴共同构建了 One Team 体系，提供涵盖专利·商标·版权全领域的申请、争议、交易，以及美国专利诉讼与专利收益化战略衔接在内的综合IP解决方案。此外，与Dentons Lee法律事务所在政策·监管及全球商业领域协作，支持国际监管应对及海外业务战略，构建了协助国内企业拓展全球市场及海外企业进入韩国市场的法律与商务基础。`,
    about_3: `与此同时，在游戏产业的各个阶段，也拥有丰富的咨询经验，包括内容授权、发行合同、知识产权及营业秘密保护、国内外监管应对等。并通过与未来+游戏咨询有限公司、QROAD、韩国移动游戏协会、韩国人工智能游戏协会等产业合作伙伴的紧密合作，建立了涵盖开发·运营·监管·政策的综合法律与商业支持体系。`,
    about_4: `这种由法律、技术、产业专家有机协作组成的One Team结构，将国际诉讼、IP、游戏·IT·内容、中国及全球业务、政策·监管咨询等所有领域自然衔接，不仅限于法律层面的应对，更通过理解整个产业并进行前瞻性支持，形成了WEthePEOPLE独有的差异化竞争力。`,
    about_5: `未来法律事务所的“未”，既寓意美好前景，亦取“为”之谐音，象征“为了客户”的核心理念。本所始终秉持客户为先的价值导向，持续致力于提供卓越的法律服务。`,
    feature_1_title: `连接技术与产业的知识产权专业实力`,

    feature_1_text: `通过与 Lee International 专利法律事务所、
Lucid Insights、Creative Answers (LICA) 以及
专利法人WethePeople的协作，我们在专利、商标、著作权全领域开展申请、争议与交易业务。
我们具备从国内外企业专利组合构建到美国专利申请与审查应对的一体化支持体系，以贯通技术与产业边界的知识产权战略，助力企业创新，强化市场竞争力。`,
    feature_2_title: `以合作拓展游戏产业的法律专业性`,
    feature_2_text: `我们具备涵盖内容授权、知识产权与商业秘密保护、国内外发行合规等在内的广泛专业能力，服务范围贯穿整个游戏产业链。从游戏开发、运营、发行到全球化拓展的各个阶段，我们系统管理潜在法律风险，并提供实务导向的解决方案。同时，通过与韩国手游协会、韩国人工智能游戏协会、QROAD等主要行业伙伴的紧密合作，结合一线实务经验与政策洞察，建立了法律与商业一体化支持体系。`,
    feature_3_title: `国际诉讼的强者，以正义与人文精神捍卫权益`,
    feature_3_text: `我们十五年来始终引领主要的全球性国际诉讼，致力于维护企业与个人的合法权益。凭借与世界知名国际诉讼专业律所Hausfeld的紧密合作，在该领域建立了无可比拟的竞争优势。`,

    feature_4_title: `China Desk – 韩中商务的战略合作伙伴`,
    feature_4_text: `我们拥有由中国执业律师出身的顾问团队与专业的中方人员，借广泛的本地网络资源，在中国企业进入韩国市场及韩国企业拓展中国市场两方面都展现出独特优势。
我们为投资、合资、知识产权等重大议题提供切实可行的解决方案。`,
  },
  samplePage: {
    title: (
      <>
        <Highlights>
          구글·애플 앱마켓 과도한 수수료,{" "}
          <span style={{ whiteSpace: "nowrap" }}> 위더피플 법률사무소가</span>
        </Highlights>
        <br />
        손해배상금을
        <Deadline> 찾아드려요 !</Deadline>
      </>
    ),
    subTitle: (
      <>
        {" "}
        지난 4년간 지불한 부당한 수수료, 집단 조정을 통해 손해 배상을
        신청하세요.
        <br />
        <WtpBlue>
          참여 비용은 없으며, 'No Win, No Fee' 원칙에 따라 진행됩니다.{" "}
        </WtpBlue>
        미국 집단소송 전문 로펌 Hausfeld와 함께 성공적인 합의를 이끌어냅니다.
      </>
    ),

    deadline: (
      <>
        {" "}
        <Highlights>추가 신청 마감: 2025년 5월 31일</Highlights>
        <br /> ( ※ 접수순으로 손해감정이 진행됩니다)
      </>
    ),

    applyBt: <>지금 바로 신청하기</>,
    learnMore: <>자세히 알아보기</>,

    section_1_title: `집단 조정 개요`,

    section_1_dec_1: (
      <>
        구글과 애플의 독점적 지위를 이용한{" "}
        <WtpBlue>30% 인앱결제 수수료</WtpBlue> 등 불공정 행위로 인해 국내 앱
        개발사들이 입은 피해에 대한 집단적 손해배상 및 합의 절차입니다.
      </>
    ),
    section_1_dec_2: (
      <>
        {" "}
        위더피플 법률사무소는 미국 집단소송 전문 로펌{" "}
        <WtpBlue>하우스펠드(Hausfeld LLP)</WtpBlue>와 공동으로 '제소 전
        화해'(합의) 형식의 손해배상을 추진하고 있습니다.
      </>
    ),
    section_1_dec_3: (
      <>
        {" "}
        하우스펠드 로펌은 2023년 미국에서 4만 8천개 앱 업체를 대리하여
        구글로부터 동일 사안의{" "}
        <WtpBlue>합의금을 성공적으로 받아낸 경험</WtpBlue>이 있습니다.
      </>
    ),
    section_1_dec_4: (
      <>
        {" "}
        위더피플 법률사무소는 앱개발사가 밀집한{" "}
        <WtpBlue>구로디지털단지에 사무국을 </WtpBlue>열어, 더 많은 개발사의
        참여를 통해 협상력을 높이고자 합니다.
      </>
    ),
    section_1_dec_5: (
      <>이제 함께 목소리를 내어 정당한 권리를 되찾을 때입니다.</>
    ),
    section_2_title: <>신청 대상</>,
    section_2_dec: (
      <>
        다음 조건에 해당하시는 국내·해외 앱 개발사(개인 개발자 포함)라면 누구나
        신청 가능합니다:
      </>
    ),

    section_2_li_1: (
      <>
        {" "}
        구글 플레이스토어 또는 애플 앱스토어를 통해 앱(게임 포함)을 유통한 경우
      </>
    ),

    section_2_li_2: (
      <>
        {" "}
        <WtpBlue>
          구글 또는 애플의 인앱결제 시스템을 사용해 수수료를 납부한 경험이 있는
          경우
        </WtpBlue>
      </>
    ),

    section_3_title: <>참여해야 하는 이유</>,
    section_3_li_1: (
      <>
        <WtpBlue>비용 부담 없이 참여 가능:</WtpBlue> 신청부터 배상금 수령까지
        개발사에는 별도의 비용 부담이 없습니다. 성공 보수 방식(No Win, No
        Fee)으로 진행됩니다.
      </>
    ),
    section_3_li_2: (
      <>
        {" "}
        <WtpBlue>높은 손해배상 가능성:</WtpBlue> 미국에서 동일 소송을 성공적으로
        수행한 하우스펠드 로펌과 협력하여 국내 게임사들의 피해에 대해 정당한
        손해배상을 받을 수 있도록 지원합니다.
      </>
    ),
    section_3_li_3: (
      <>
        {" "}
        <WtpBlue>의미 있는 배상 규모 예상:</WtpBlue> 제출된 자료에 대한 전문
        손해 감정을 통해, 실제 손실을 반영한 합리적인 배상금이 산정됩니다.
      </>
    ),
    section_3_li_4: (
      <>
        {" "}
        <WtpBlue>국내외 전문가의 공동 대응:</WtpBlue> 국내 법률 전문가 위더피플
        법률사무소와 미국 하우스펠드 로펌이 긴밀히 협력하여 개발사의 권익 보호를
        함께 이끌어갑니다.
      </>
    ),
    section_3_li_5: (
      <>
        {" "}
        <WtpBlue>더 나은 제도 개선의 시작점:</WtpBlue> 이번 조정 참여는 단순한
        배상에 그치지 않고, 장기적으로 더 공정하고 투명한 수수료 정책이 마련되는
        계기가 될 수 있습니다.
      </>
    ),
    section_3_li_6: (
      <>
        {" "}
        <WtpBlue>집단 대응을 통한 실질적 해결:</WtpBlue> 개별 소송의 부담 없이,
        집단의 힘을 통해 대형 플랫폼 기업에 보다 효과적으로 대응할 수 있는
        현실적인 해결 방안입니다.
      </>
    ),
    section_4_title: <>플랫폼의 보복 조치가 걱정되시나요?</>,

    section_4_des_1: (
      <>
        {" "}
        <WtpBlue>
          이번 미국 집단조정은 앱 개발사와 구글·애플 간 체결된 계약에 따라
          미국법이 적용되며, 참여 기업은 미국 법원의 보호 아래 보복 우려 없이
          안전하게 권리를 행사할 수 있습니다.
        </WtpBlue>
      </>
    ),
    section_4_des_2: (
      <>
        실제로 지금까지 구글과 애플을 상대로 수많은 기업이 개별 및 집단 소송,
        청구권 협상에 참여했으나, 보복 피해 사례는 단 한 건도 보고된 바
        없습니다.
      </>
    ),
    section_4_li_1: <>구글 집단소송: 약 4만 8천개 미국 앱 업체</>,
    section_4_li_2: <>애플 집단소송: 약 6만 7천개 미국 앱 업체</>,
    section_4_li_3: <>미국 소비자 대상 손해배상 합의: 약 9,100억 원</>,

    section_4_des_3: (
      <>
        {" "}
        총 배상 합의금 규모는 약 1조 1천억 원에 달하며, 그 과정에서 앱 업체들에
        대한 위협이나 보복 행위는 확인되지 않았습니다.
      </>
    ),
    section_4_des_4: (
      <>
        {" "}
        <WtpBlue>미국 반독점법 (Sherman Act) </WtpBlue>{" "}
      </>
    ),
    section_4_des_4_5: (
      <>미국법은 영업보복 행위 자체를 또 다른 반독점법 위반으로 간주합니다.</>
    ),
    section_4_des_5: (
      <>
        {" "}
        위반 시, 위법 행위 1건당 최대 1억 달러의 벌금 또는 최대 10년 이하의 징역
      </>
    ),
    section_4_des_6: <> 민사상으로는 3배의 징벌적 손해배상 가능</>,
    section_4_des_7: (
      <>
        {" "}
        <WtpBlue>미국법원 판례</WtpBlue>
      </>
    ),
    section_4_des_8: <> 기업에는 거래 상대방 선택의 자유가 있으나,</>,
    section_4_li_4: <> 소송 방해 또는 독점 유지 목적의 조치는 불법이며,</>,
    section_4_li_5: (
      <>
        {" "}
        영업관계의 일방적 중단, 종료 또는 영업방해 등 보복 행위가 발생할 경우,
      </>
    ),

    section_4_des_9: (
      <> 법원은 즉각적인 금지명령(injunction)을 통해 이를 차단합니다.</>
    ),
    section_5_title: <> 신청 절차</>,
    section_5_sub: (
      <>
        {" "}
        집단 조정 신청부터 배상까지의 절차는 다음과 같이 진행됩니다. (미국 집단
        조정 절차 기준, 통상 6개월~1년 소요)
      </>
    ),
    section_5_table: [
      {
        title: "신청 접수 (온라인)",
        description:
          "홈페이지를 통해 개발사 기본 정보를 입력하고 신청서를 제출합니다.",
      },
      {
        title: "검토 및 상담",
        description:
          "제출된 신청서를 바탕으로 위더피플 법률사무소에서 신청 기업 자료 요청 및 상담을 진행합니다.",
      },
      {
        title: "손해액 산정 및 심사",
        description:
          "미국 집단소송 전문 로펌 하우스펠드가 제출된 자료를 검토하여 개발사별 손해액을 감정하고 심사합니다.",
      },
      {
        title: "조정/합의 진행",
        description:
          "위더피플 법률사무소와 하우스펠드 로펌이 개발사를 대리하여 구글/애플과 제소 전 손해배상 합의를 위한 협상을 진행합니다. \n( 미국 전담 중재인 Mediator Layn Phillips )",
      },
      {
        title: "결과 통보 및 배상",
        description:
          "합의가 성공적으로 이루어지면, 그 결과를 참여 개발사에게 통보하고 합의된 배상금을 지급하는 절차를 진행합니다.",
      },
    ],
    section_6_title: "신청 방법",
    section_6_des_1: (
      <>
        신청 마감: <Deadline>2025년 5월 31일 </Deadline>{" "}
      </>
    ),
    section_6_des_2: <>(접수순으로 진행됨)</>,
    section_6_des_3: (
      <>아래 버튼을 클릭하여 지금 바로 집단 조정 참여를 신청하세요!</>
    ),
    section_6_des_4: "신청하기",

    section_6_des_5: (
      <>
        {" "}
        신청서 접수 후, 위더피플 인앱피해 공동대응 사무국 담당자가 내용 확인을
        위해 연락드릴 예정입니다.
        <br />
        신청 과정에 대해 궁금한 점이 있으시면 언제든지 아래 연락처로
        문의해주세요.
      </>
    ),
    section_7_title: "문의처",
    section_7_des_1: (
      <>
        집단 조정 참여와 관련하여 궁금한 점이 있으시면 언제든지 연락 주시기
        바랍니다.
      </>
    ),
    section_7_des_2: (
      <>
        <WtpBlue>담당:</WtpBlue> 위더피플 인앱피해 공동대응 사무국/사무국장
        김서윤, 위더피플 법률사무소 / 이영기 외국 변호사
      </>
    ),
    section_7_des_3: (
      <>
        {" "}
        <WtpBlue>전화:</WtpBlue> 070-4699-0107 / 010-8485-5743 / 팩스:
        050-4171-8975
      </>
    ),
    section_7_des_4: <>이메일</>,
    section_7_des_4_5: <>신청 페이지</>,
    section_7_des_5: (
      <>
        <WtpBlue>주소:</WtpBlue> 서울시 구로구 디지털로31길 20,
        에이스테크노타워5차 704호
      </>
    ),
  },
  apply: {
    m: "유효한 이메일 주소를 입력해주세요.",
    file: "파일은 5MB 이하만 업로드할 수 있습니다.",
    alert: "상담 신청이 잘 접수되었습니다. 곧 연락 드리겠습니다.",
    title: "집단 조정 상담 신청서",
    A_1: (
      <>
        <Red>[필수]</Red> 회사명(국문)
      </>
    ),
    A_2: <>[선택] 회사명(영문)</>,
    A_3: (
      <>
        {" "}
        [법인] 법인등기부상 영문명과 동일{"\n"}
        [개인사업자] 영문사업자명 정확하게 기재
      </>
    ),
    A_4: (
      <>
        {" "}
        <Red>[필수]</Red> 대표자명(국문)
      </>
    ),
    A_5: <>[선택] 대표자명(영문)</>,
    A_6: <>여권상 영문명과 동일</>,
    A_7: (
      <>
        {" "}
        <Red>[필수]</Red> 담당자명
      </>
    ),
    A_8: (
      <>
        <Red>[필수]</Red> 휴대폰번호
      </>
    ),
    A_9: <>[선택] 회사전화번호</>,
    A_10: (
      <>
        <Red>[필수]</Red> 이메일
      </>
    ),

    A_11: <>[첨부] 위임장 양식</>,
    A_12: <>다운로드</>,
    A_13: <> [선택] [제출서류] [위임장 날인본] [업로드]</>,
    A_13_5: <> 첨부하기</>,

    A_14: <>선택된 파일 없음</>,
    A_15: <> * 혹은 사무국 이메일로 제출{" \n"}</>,
    A_16: (
      <>
        {" "}
        개인정보 수집 및 이용에 동의합니다.
        <br />
        수집 항목: 성명/회사명, 전화번호, 이메일
        <br />
        수집 목적: 집단 조정 절차의 상담
        <br />
        보유 및 이용 기간: 조정 절차 종료 후 1년까지 보관 후 파기
        <br />
        귀하는 동의를 거부할 권리가 있으며, 다만 동의하지 않을 경우 신청이
        제한될 수 있습니다.
      </>
    ),
    A_17: <>신청서 제출</>,
  },

  footer: {
    mainTitle: `未来法律事务所`,
    mainText_1: `未来的“未”，是取自"为"的谐音，寓意“为了客户”。
                `,
    mainText_2: `
                我们将成为您值得信赖的法律与商业合作伙伴`,
    tel: `咨询处`,
    map: `韩国首尔市西大门区京畿大学路47, 进洋大厦7楼`,
    phone: `02-2101-0750`,
    sub: `未来律所应用程式支付违法行为联合应对事务局`,
    subMap_1: `韩国首尔特别市九老区数码路31街20号`,
    subMap_2: `Ace Techno Tower第5期704室`,
    subp_1: "070-4699-0107",
    subp_2: "010-8485-5743",
    subp_3: "050-4171-8975",
    fax: `传真`,
  },
  header: {
    nav: {
      home: "首页",
      intro: "介绍",
      practice: "专业领域",
      member: "成员",
      notice: "公告",

      international: "共享价值诉讼中心",
      monetization: "IP 收益化中心",
      news: "新闻",
      cases: "主要案例",
      insight: "洞察",
      Partners: "Family Site",
      wethepeople: "专利法人未来",
      pharos: "劳务法人pharos",
      game: "(社)韩国手游协会",
      indie: "(社)韩国人工智能游戏协会",
      updates: "消息",
      publications: "专栏文章",
      newsletters: "新闻简报",
      recruit: "Ongoing Cases",

      track: "主要 Track Record",
      contact: "咨询",
    },
  },
  homepage: {
    slider: [
      {
        id: 1,
        backgroundImage: "/images/home/main_1.png",
        title: "以信赖和专业与您同行的法律伙伴",
        subtitle:
          "未来律师事务所在知识产权、企业一般法律业务、诉讼等多个领域提供定制化法律服务",
        buttonText: "법률 상담 문의하기",
        buttonLink: "/contact",
      },
      {
        id: 2,
        backgroundImage: "/images/home/main_5.png",
        title: "专业的法律团队在全球具备竞争力",
        subtitle: "针对国内外复杂的法律问题，提供最好的解决方案。",
        buttonText: "더 알아보기",
        buttonLink: "/about",
      },
      {
        id: 3,
        backgroundImage: "/images/home/main_3.png",
        title: "为了保护客户权益与助力客户成功，定必全力以赴。",
        subtitle: " 未来的“未”，是取自'为'的谐音，寓意“为了客户。",
        buttonText: "성공 사례 보기",
        buttonLink: "/cases",
      },
    ],
    search: "搜索成员",
    searchEx: "用名字搜索",
    searchBt: "搜索",
    popImage: "/images/event/popup.png",
  },
  PracticeAreasPage: {
    title: "专业领域",
    practice: "业务领域",
    sector: "产业领域",

    special: "核心能力及特色服务",
    normal: "业务范围",
    learnMore: "查看详情",
  },
  PracticeAreasDetailPage: {
    home: "首页",
    area: "专业领域",
    introduction: "介绍",
    service: "主要服务",
  },
  memberPage: {
    professionals: "成员",
    proSearch: "搜索成员",
    search: "搜索",
    holder: "用名字搜索",
  },
  memberDetailPage: {
    home: "首页",
    member: "成员",
    intro: "Introduction",
    history: "经历",
    education: "学历",
    performance: "主要业绩",
    lan: "精通语言",
    insight: "洞察",
    awards: "奖项与荣誉",
    qualifications: "资历",
  },
  noticePage: {
    home: "公告",
  },
  noticeDetailPage: {
    home: "首页",
    announcements: "公告",
    backtoList: "返回列表",
    previous: "上一篇",
    next: "下一篇",
  },
  casePage: {
    home: "主要 Track Record",
  },
  caseDetailPage: {
    home: "Home",
    keyCases: "主要 Track Record",
    backtoList: "Back to List",
    previous: "Previous",
    next: "Next",
  },

  internationalPage: {
    title: "共享价值诉讼中心",
    overview: (
      <>
        “共享价值创造（Creating Shared
        Value，CSV）”是指企业的经济价值创造与社会价值提升并非相互对立，而是在企业改善经济与社会环境的过程中，企业与股东的价值能够同步提升的理念。该理念强调，企业在参与解决社会问题的同时，实现可持续的经济成果，是一种重要的经营战略。在当今强调ESG经营的背景下，其重要性愈发凸显。
        <br />
        未来法律事务所 CSV Litigation Center
        致力于将CSV理念具体落实于诉讼领域。全球企业的合谋行为、环境与消费者损害、扰乱市场秩序的行为以及个人信息泄露等，不仅破坏社会整体信任，也会对企业及股东的经济价值造成严重损害。通过明确相关侵害行为的法律责任，方可防止类似问题再次发生，并实现实质性的恢复。
        <br />
        CSV Litigation Center
        针对侵害企业、股东及社会应共同享有价值的重大违法行为，开展大规模损害赔偿诉讼、股东代表诉讼及公益性责任追究诉讼等法律行动。同时，不仅限于国内诉讼，也在跨境诉讼（Cross-Border
        Litigation）领域寻求综合性的解决方案。
        <br />
        CSV Litigation Center
        的目标并非止步于短期损害的弥补或个别争议的解决，而是致力于推动责任与合规的制度结构在企业与市场中长期落地。
        <br />
      </>
    ),

    whyUs: (
      <>
        {" "}
        <Item>
          <Description>
            在过去15年间，未来法律事务所围绕因全球企业合谋及不正当竞争等违法行为所引发的国内损害案件，在国内外法院代理了涵盖大型企业、中坚企业、中小企业及个人在内的多元化客户群体，并持续积累了具有实质意义的成果。{" "}
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            具有大规模、集体性特征的诉讼，往往因程序复杂、证据获取难度高及费用结构等因素而具备较高的进入门槛。CSV
            Litigation Center
            针对原告群体构成、证据获取与分析、多层次损害结构的厘清、诉讼策略制定，以及谈判与判决阶段，实施覆盖诉讼全流程的战略性应对。{" "}
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            同时，通过无需前期费用、以成功报酬为基础的“No Win, No
            Fee”诉讼模式，确保委托人的正当权利救济不因成本问题受到限制，并坚持以结果为导向推进案件。{" "}
          </Description>{" "}
        </Item>
        <Item>
          <Description>
            在跨境诉讼（Cross-Border Litigation）领域，CSV Litigation Center
            依托与 Hausfeld LLP、Cohen Milstein LLP、Saxena White P.A.
            等世界知名国际诉讼专业律师事务所的紧密合作，针对国内委托人难以单独应对的全球性争议，主导设计并实施共同诉讼及集体性应对结构。{" "}
          </Description>
        </Item>
      </>
    ),

    services: (
      <>
        <div>
          <Title>1. 针对共享价值侵害的责任诉讼 </Title>
          <Item>
            <Description>
              追究全球企业合谋、不正当交易及限制竞争行为的法律责任
            </Description>
            <Description>
              处理环境、消费者、金融及投资者损害等集体性损失案件
            </Description>
          </Item>{" "}
        </div>
        <div>
          <Title>2. 股东及利益相关方权利保护</Title>
          <Item>
            <Description>股东代表诉讼及管理层责任相关争议</Description>
            <Description>因违法行为导致企业价值受损的恢复策略</Description>{" "}
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>3. 集体诉讼结构设计</Title>
          <Item>
            <Description>损害与责任结构分析及原告群体构成</Description>
            <Description>
              证据获取与分析，以及损害金额的测算与证明策略
            </Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>4. 国际诉讼及联合应对</Title>
          <Item>
            <Description>基于与海外律师事务所合作的共同诉讼 </Description>
            <Description>战略性管辖地选择及全球和解程序支持</Description>
            <Description>
              应对美国州法院、联邦法院及 ITC 等主要海外司法管辖机构
            </Description>
          </Item>{" "}
        </div>
      </>
    ),
  },
  monetizationPage: {
    title: "IP 收益化中心",
    overview: (
      <>
        未来法律事务所 IP 收益化中心（IP Monetization
        Center）是以知识产权（Intellectual Property
        Right，IPR）为基础，设计并落地收益结构的专业化知识产权收益化组织。
        知识产权收益化（IP Monetization）主要通过以下两种方式实现：
        <Title>1. 基于侵权的收益化 </Title>
        <Item>
          <Description>
            通过针对侵权人的损害赔偿诉讼或许可谈判，获取专利使用费（Royalty）。
          </Description>
        </Item>
        <Title>2. 基于交易的收益化</Title>
        <Item>
          <Description>
            通过资产出售、对外许可（Licensing-out）等方式实现资产化并创造现金流。
          </Description>
        </Item>
        上述收益化方式将根据权利属性及市场环境进行战略性选择与组合运用。
        <br /> <br />{" "}
        <SectionHeader>
          <Diamond>◆</Diamond>
          <DTitle>
            <Bold>专利领域</Bold>
          </DTitle>
          <DLine />
        </SectionHeader>
        专利并非仅是排他性权利，而是可通过侵权应对及交易结构实现价值最大化的核心商业资产。IP
        收益化中心围绕收益化对象专利的发掘、价值与侵权分析、市场及目标对象调研、诉讼与谈判、交易达成等环节，系统性地开展专利收益化全流程工作。{" "}
        <br /> <br />
        同时，本中心自研发（R&D）阶段起即支持以收益创造为导向的专利组合设计战略，并提供国内外专利申请及权利范围优化相关服务。
        中小企业、高校及科研机构等主体，往往未能充分发挥其所持专利的价值，或未能识别其收益化潜力。对此，本所通过美国及韩国专利专业律师、专利代理人与具备大型科技企业背景的IP专家之间的协作，对客户的专利组合进行全面分析，并提出具备可行性的收益化模型。
        <br /> <br />
        <SectionHeader>
          <Diamond>◆</Diamond>
          <DTitle>
            <Bold>商标 / 外观设计 / 著作权领域</Bold>
          </DTitle>
          <DLine />
        </SectionHeader>
        商标、外观设计及著作权同样属于可通过侵权诉讼、权利转让及许可实现收益的商业资产。IP
        收益化中心（IP Monetization
        Center）通过针对侵权人的损害赔偿请求与许可谈判，以及 IP
        的转让与对外许可，实现相关权利的经济价值。
        在此基础上，本中心进一步设计法律结构，使 IP
        能够通过品牌管理、内容产业以及衍生产品与服务等方式实现收益化。在该过程中，围绕权利范围、收益归属、合同结构及侵权风险进行系统分析，确保
        IP 的运用能够形成稳定且可持续的收益模式。
        此外，依托与姊妹机构构建的协作网络，本中心支持既有 IP
        在音乐、电影、时尚、角色、表演艺术等多元产业领域中拓展为新的收益模型。
      </>
    ),
    whyUs: (
      <>
        <Item>
          <Description>
            不同于通过收购专利并直接获取收益的一般性 NPE（Non-Practicing
            Entity），本中心在不转移权利的前提下，支持权利人持续持有
            IP，并实现与后续业务拓展、技术延伸相结合的可持续收益化。
          </Description>
        </Item>
        <Item>
          <Description>
            由曾在 LG、三星、首尔半导体等企业中统筹 IP
            战略及美国专利诉讼的专业人士组成，从企业经营视角出发，将收益化结构与企业业务战略有机衔接并加以设计。
          </Description>
        </Item>
        <Item>
          <Description>
            来自国内外大型律师事务所的专利专业美国律师及美国专利代理人，与美国知名专利律师事务所及
            e-Discovery 服务机构协作，围绕美国市场开展高附加值的收益化业务。
          </Description>
        </Item>
        <Item>
          <Description>
            依托与 Lee International 专利法律事务所、WEthePEOPLE
            专利法人、Creative Answers（LICA）
            等姊妹机构的协作网络，整合约100名专利代理人及约300名工程师资源，实现从
            IP 分析、技术验证到交易匹配的联动支持。
          </Description>
        </Item>
        <Item>
          <Description>
            通过成功报酬制、混合型模式等灵活的费用结构，最大限度降低权利人的前期负担。
          </Description>
        </Item>
        <Item>
          <Description>
            在商标、外观设计及著作权领域，依托与 Infinite Group Co., Ltd.（CI·BI
            设计专业机构）、Infinis Co.,
            Ltd.（品牌管理专业机构）等姊妹公司的协作，为 IP
            基础业务扩展设计相应的法律结构。
          </Description>
        </Item>
        <Item>
          <Description>
            基于过去 15
            年积累的全球诉讼经验，将“权利保护、侵权遏制、实现正当补偿”的理念，系统性地应用于
            IP 收益化业务的整体实践中。
          </Description>
        </Item>{" "}
      </>
    ),
    services: (
      <>
        <div>
          <Title>1.IP 组合构建及战略设计</Title>
          <Item>
            <Description>以收益化为导向的 IP 组合设计</Description>
            <Description>通过美国直接申请，协助获取海外权利</Description>
            <Description>
              专利申请战略制定及权利范围优化（包括美国直接申请、审查意见答复〔Office
              Action，OA〕、继续申请〔Continuation Application，CA〕等）
            </Description>
          </Item>{" "}
        </div>
        <div>
          <Title>2. 基于侵权的收益化</Title>
          <Item>
            <Description>IP 侵权分析、市场调研、目标方调查</Description>
            <Description>
              通过国内外诉讼及许可谈判获取损害赔偿及专利使用费
            </Description>{" "}
            <Description>
              应对美国诉讼及 ITC 程序，并对接诉讼费用融资方案
            </Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>3. 基于交易的收益化</Title>
          <Item>
            <Description>
              IP 转让及对外许可（Licensing-out）结构设计
            </Description>
            <Description>调研并匹配具备收购或许可意向的企业</Description>
            <Description>提供合同起草、谈判支持及法律审查服务</Description>
          </Item>{" "}
        </div>{" "}
        <div>
          <Title>4. IP 商业化及扩展结构设计</Title>
          <Item>
            <Description>
              基于商标、外观设计及著作权的品牌与内容业务商业化结构设计
            </Description>
            <Description>
              在充分考虑收益归属、权利保护及侵权风险的基础上，设计相应的合同与许可结构{" "}
            </Description>
          </Item>{" "}
        </div>{" "}
      </>
    ),
  },
  newsPage: {
    home: "新闻",
  },
  publicationPage: {
    home: "专栏文章",
    category: "分类",
    year: "年份",
    search: "搜索",
    searchPlaceholder: "按作者或标题搜索",
    all: "全部",
    total: "总数",
    sampleData: "正在显示示例数据",
    loading: "加载中...",
    date: "日期",
    title: "标题",
    author: "作者",
    empty: "没有搜索结果。",
  },
  publicationDetailPage: {
    home: "首页",
    publications: "专栏文章",
    backToList: "返回列表",
    previous: "上一篇",
    next: "下一篇",
    loading: "加载中...",
    notFound: "未找到专栏文章。",
  },
  techHomePage: {
    heroTitle: "为科技企业的成长、技术权益保护、海外拓展与争议应对提供整体规划",
    heroText:
      "未来法律事务所以科技企业法律顾问业务为核心，提供知识产权与技术权益、海外拓展与出口、美国业务与诉讼等法律服务。围绕技术商业化、跨境交易、关税与贸易以及争议应对的各个环节，为客户提供所需的法律支持。",
    contactButton: "立即咨询",
    what: {
      eyebrow: "WHAT",
      title: "我们的服务",
      lead: "我们的业务涵盖四大领域：科技企业法律顾问、知识产权与技术权益、海外拓展与出口、美国业务与诉讼。",
    },
    works: [
      {
        icon: "building",
        title: "科技企业法律顾问",
        text: "结合技术与知识产权特点，为企业提供投融资、合同、组织运营及争议预防支持。",
      },
      {
        icon: "fingerprint",
        title: "知识产权与技术权益战略",
        text: "知识产权与技术权益战略	统筹权利布局、技术保护、知识产权交易与价值实现，以及境内外争议应对。",
      },
      {
        icon: "globe",
        title: "海外拓展与出口法律服务",
        text: "支持海外投资与跨境交易，以及关税、通关、退税、出口管制与供应链合规。",
      },
      {
        icon: "scale-balanced",
        title: "美国业务与诉讼应对",
        text: "协助应对美国市场准入与业务运营、关税与贸易程序，以及技术和商事争议。",
      },
    ],
    who: {
      eyebrow: "WHO",
      title: "专业团队与协作网络",
      lead: "根据具体事项的需要，我们与律师、外国律师、专利代理师、韩国关税师、会计·税务专家以及境外律所协作",
      note: "未来法律事务所负责制定核心法律策略并与客户直接沟通。必要时，我们将与知识产权、关税与贸易、美国法及韩国企业法律事务等领域的专业人士协作，统筹服务范围、进度与费用，并统一管理交付成果",
    },
    network: [
      ["律师", "科技企业法律顾问、合同与交易、反垄断与争议、韩国境内诉讼"],
      ["外国律师", "美国业务与诉讼、国际合同及境外法律咨询"],
      ["专利代理师", "专利、商标、外观设计权利布局、技术保护、知识产权交易与\n价值实现及争议解决"],
      ["关税师", "商品归类、完税价格、原产地、关税、通关、退税、关税调查与行政救济"],
      ["境外律所", "当地法咨询、美国及其他国家和地区的\n诉讼与关税程序、监管与争议协同办理"],
      ["会计·税务协作", "境外公司、税务与转让定价、交易架构相关税务咨询"],
    ],
    whyEyebrow: "Why WEthePEOPLE",
    whyTitle: "契合科技企业商业模式的专业能力",
    why: [
      ["以科技企业为核心的一体化法律服务", "综合分析商业模式与技术资产，为企业不同成长阶段提供适配的法律架构。"],
      ["知识产权、美国诉讼与关税事务协同", "围绕交易与争议的实际进程，统筹知识产权保护与价值实现、美国诉讼以及关税与贸易应对。"],
      ["由未来法律事务所统筹的协作机制", "由未来法律事务所制定核心法律策略并与客户直接沟通，必要时协同韩国及境外专家和境外律所开展工作。"],
    ],
    footerTitle: "与我们一起审查科技企业的法律课题",
    footerLead: "WEthePEOPLE 将作为值得信赖的法律伙伴，陪伴科技企业成长和全球扩张。",
    firmName: "未来法律事务所 ",
    address: "韩国首尔市西大门区京畿大学路47, 进洋大厦7楼",
    tel: "02-2101-0750",
    email: "wtp@wtplaw.co.kr",
    privacyLabel: "个人信息处理方针",
    termsLabel: "使用条款",
  },
  techPracticePage: {
    title: "专业领域",
    areas: [
      {
        title: "科技企业法律顾问",
        intro:
          "结合科技企业的发展阶段与商业模式，审查投融资、合同、组织运营及争议预防相关法律问题。充分考虑技术与知识产权的特点，提前梳理企业在韩国境内经营过程中可能面临的法律风险。",
        items: [
          ["成长与投融资架构", "公司设立与股权结构、种子轮及系列融资、股东协议、股权激励、并购及业务转让"],
          ["技术合作与战略合同", "共同开发与概念验证（PoC）、OEM/ODM与供货、平台与SaaS、经销与总代理、技术转让与许可"],
          ["公司治理与合规 ", "董事会与股东会、内部控制、个人信息与数据、员工管理、职务发明与商业秘密"],
          ["经营风险与争议预防 ", "合同审查与风险诊断、公司治理/劳动人事/交易争议；谈判、调解及诉讼前期策略"],
        ],
      },
      {
        title: "知识产权与技术权益战略",
        intro:
          "统筹技术与品牌的权利布局、商业秘密保护、知识产权交易以及境内外维权。我们与专利事务所及专利代理师协作，助力知识产权从申请注册进一步转化为交易与商业化价值。",
        items: [
          ["技术与品牌权利布局 ", "发明挖掘、专利/商标/外观设计组合、境内外申请与注册、权利范围设计"],
          ["商业秘密与技术保护体系 ", "保密管理、职务发明与成果权属、技术资料提供与对外移交、技术泄露应对"],
          ["知识产权交易与价值实现 ", "技术转让与许可、共同开发与商业化、许可费安排、知识产权估值与投融资对接"],
          ["境内外维权与争议解决 ", "侵权调查、警告函与谈判；知识产权行政审理与诉讼；无效程序与规避设计；境外维权及当地律所协作"],
        ],
      },
      {
        title: "海外拓展与出口法律服务",
        intro:
          "统筹海外市场准入、跨境交易架构、关税与通关、出口管制与经济制裁等科技企业开展海外业务所需的法律及贸易事务。需要审查当地法律时，我们将与相应国家或地区的律所协作，并由未来法律事务所负责与韩国客户沟通及统筹整体工作。",
        items: [
          ["海外拓展与投资架构 ", "当地公司与分支机构、合资与战略合作、公司治理、对接当地许可及劳动用工专家"],
          ["跨境交易与技术商业合同 ", "海外销售与采购、经销与总代理、OEM/ODM、国际许可、付款、担保与物流条件"],
          ["韩国关税、通关与退税 ", "商品归类、完税价格与原产地；FTA；关税优化与退税；关税调查与行政救济"],
          ["出口管制、经济制裁与供应链监管 ", "战略物资与技术出口、制裁对象筛查、强迫劳动与原产地监管、当地监管应对"],
        ],
      },
      {
        title: "美国业务与诉讼应对",
        intro:
          "统筹美国市场准入与业务运营、关税与贸易程序，以及技术和商事争议。未来法律事务所直接与韩国客户沟通，主导与美国当地律所的协作、材料准备及法律策略制定。",
        items: [
          ["美国市场准入与业务运营 ", "公司及投资架构、商业合同、劳动用工、个人信息与合规、各州监管要求"],
          ["美国关税与贸易程序 ", "关税征收与退税；美国海关与边境保护局（CBP）行政程序；IEEPA及Section 201、232、301项下加征关税；美国国际贸易法院（CIT）及联邦巡回上诉法院诉讼协同应对"],
          ["商事、技术及知识产权诉讼 ", "国际合同、股东、产品及技术争议；证据开示与证据保全；仲裁与诉讼；与当地律所共同办理"],
          ["美国政府调查与监管应对 ", "应对美国司法部（DOJ）、联邦贸易委员会（FTC）等政府调查；并购申报（HSR）与审查；出口管制与制裁合规；内部调查与整改措施"],
        ],
      },
    ],
    firmName: "WEthePEOPLE 法律事务所",
    address: "首尔特别市西大门区京畿大路47，真阳大厦7层",
    tel: "02-2101-0750",
    email: "wtp@wtplaw.co.kr",
  },
  techContactPage: {
    title: "联系我们",
    lead: "请填写下方表单，负责律师将在审阅后尽快与您联系。",
    nameLabel: "姓名（必填）",
    namePlaceholder: "张三",
    companyLabel: "公司 / 所属机构",
    companyPlaceholder: "WEthePEOPLE 株式会社",
    emailLabel: "电子邮箱（必填）",
    emailPlaceholder: "name@company.com",
    phoneLabel: "联系电话",
    phonePlaceholder: "010-0000-0000",
    urgentPhone: "+82-2-2101-0750",
    urgentPhoneHref: "tel:+82221010750",
    categoryLabel: "咨询领域",
    categories: ["科技企业法律顾问", "知识产权与技术权益", "海外拓展与出口", "美国业务与诉讼", "反垄断与平台监管", "人事与劳动用工","其他"],
    messageLabel: "咨询内容（必填）",
    messagePlaceholder: "请简要说明事项及相关背景。",
    privacyText: "本人同意为咨询回复目的收集和使用个人信息，并保存一年。",
    privacyLink: "查看详情",
    submitButton: "提交咨询",
    submittingButton: "提交中...",
    requiredMessage: "姓名、电子邮件、咨询内容和个人信息同意为必填项。",
    successMessage: "咨询已提交。我们会尽快回复。",
    errorMessage: "提交咨询时发生错误。请稍后再试。",
    processTitle: "咨询流程",
    steps: [
      { title: "提交咨询", text: "提交表单后，相关团队将对咨询事项进行初步确认。" },
      { title: "安排负责律师", text: "根据咨询领域，安排相应的律师、专利代理师或关税师。" },
      { title: "回复与咨询", text: "完成初步审阅后，我们将尽快回复；必要时可安排线下或视频咨询" },
    ],
    urgentTitle: "事项紧急吗？",
    urgentText: "工作日 09:00-18:00 可通过电话直接联系负责人员。",
  },
  popup: {
    dontOpen: "Don’t show this again today",
    close: "Close",
  },
  slider: {
    insight: "Insights",
  },
  parter: {
    title: "合作伙伴",
    sub: "主要合作伙伴",
  },
};

export default Cn;
